export default __webpack_public_path__ + "static/media/img2.c4b6a709.png";